require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-c-4-wpx-brrju-kkt-pe-8-rbf-j-tgg.json") })
        }
      }, "path---news-c-4-wpx-brrju-kkt-pe-8-rbf-j-tgg");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-c-4-wpx-brrju-kkt-pe-8-rbf-j-tgg!./.cache/json/news-c-4-wpx-brrju-kkt-pe-8-rbf-j-tgg.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---news-c-4-wpx-brrju-kkt-pe-8-rbf-j-tgg!./.cache/json/news-c-4-wpx-brrju-kkt-pe-8-rbf-j-tgg.json
// module chunks = 231608221292675